import React from "react"
import { Link } from "react-router-dom";
import { Button } from "antd"
import { PlusOutlined } from "@ant-design/icons"
/* custom component */
import Header from "../../../../component/Header/Header"
import { PageContainer } from "../../../../component/Xcomponent"
import ContentRepoList from "../../../../component/ContentRepo/ContentRepoList/ContentRepoList";

const ContentRepoDoctorList = props => {

    return (
        <>
            <Header
                title="Content Repo Doctor List"
                rightChildren={<Link to="/content-repo-doctor/add" ><Button type="primary" ><PlusOutlined />New</Button></Link>}
            />
            <PageContainer>
                <ContentRepoList refreshPageUrl={`content-repo-doctor/list`} pageUrl={`content-repo-doctor`} pageType="Doctor" />
            </PageContainer>
        </>
    )
}

export default ContentRepoDoctorList